import useTranslation from 'next-translate/useTranslation';
import { memo, useEffect, useState } from 'react';

import { Translate } from '@core/constant';
import { useContextMediaQuery } from '@core/context';
import { useScrollDirection } from '@core/hook';
import {
  EColor,
  EFontWeight,
  EIcon,
  EPosition,
  ESize,
  ETypographyVariant,
  EZIndexName,
} from '@core/type';

import { Icon } from '../icon';
import { Box } from '../layout/Box';
import { Typography } from '../typography/Typography';

const SIZE = '56px';
const MIN_VALUE_TO_DISPLAY = 300;

const ButtonTopMobileContainer = () => {
  const { isUp } = useScrollDirection(0);
  const { isDesktop } = useContextMediaQuery();
  const { t } = useTranslation(Translate.common.BUTTON);

  const [scrollPosition, setScrollPosition] = useState(0);
  const [isUnderToDisplay, setIsUnderToDisplay] = useState(false);

  useEffect(() => {
    setIsUnderToDisplay(isUp && scrollPosition > MIN_VALUE_TO_DISPLAY);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUp, scrollPosition]);

  const handleScroll = () => {
    const position = window.scrollY;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (isDesktop) {
    return <></>;
  }

  return (
    <Box
      onClick={onClick}
      position={'fixed'}
      zIndex={EZIndexName.FIXED}
      left={`calc(50% - ${SIZE} / 2)`}
      bottom={isUnderToDisplay ? '24px' : `calc(-24px - ${SIZE})`}
      width={SIZE}
      height={SIZE}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      flexDirection={'column'}
      textAlign={'center'}
      backgroundColor={{ semanticType: EColor.NEUTRAL, variant: EColor.LIGHT }}
      borderRadius={'50%'}
      transition={'0.3s'}
      boxShadow={EColor.ELEVATION_2}
    >
      <Icon
        type={EIcon.ANGLE}
        color={EColor.ACCENT}
        orientation={EPosition.TOP}
        size={ESize.MD}
        marginTop={'-6px'}
      />
      <Typography
        color={EColor.ACCENT}
        variant={ETypographyVariant.CAPTION1}
        fontWeight={EFontWeight.MEDIUM}
        textTransform={'uppercase'}
      >
        {t('topMobile.title')}
      </Typography>
    </Box>
  );
};

export const ButtonTopMobile = memo(ButtonTopMobileContainer);
